import { ClientContactInfo } from './models/clientContactModel';
import { objectUtils } from '@/app/core/utils';
import {
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
  Text,
} from '@chakra-ui/react';
import { AiOutlineDown } from 'react-icons/ai/index.js';
import { Fragment } from 'react';

export interface ContactPickerProps {
  contacts?: ClientContactInfo[];
  inputContact?: ClientContactInfo;
  contactType: string | ((contact: ClientContactInfo) => boolean);
  onContactSelected: (contact: ClientContactInfo) => void;
}

const ContactDetails = (props: {
  contact: ClientContactInfo;
  isLastEntry: boolean;
}) => {
  const { contact } = props;
  return (
    <Stack px={5} direction={['row', 'column']} fontSize='sm'>
      <Text fontWeight='semibold'>{contact?.clientName}</Text>
      <Text>{contact?.clientUserName}</Text>
      <Text>{contact?.clientUserEmail}</Text>
    </Stack>
  );
};

export const ContactPicker = (props: ContactPickerProps) => {
  const { contacts, contactType, onContactSelected } = props;
  const filteredContacts =
    typeof contactType === 'string'
      ? contacts?.filter(
          (a) => a.recordType?.toLowerCase() === contactType.toLowerCase(),
        ) || []
      : contacts?.filter(contactType) || [];
  const canShowDropdown = filteredContacts.length > 0;
  const selectedContacts: string[] = [];
  filteredContacts.forEach((clientContact, index) => {
    if (
      props.inputContact &&
      objectUtils.areEqual(clientContact, props.inputContact, '_id')
    ) {
      selectedContacts.push(index.toString());
    }
  });

  const Contacts = () => {
    return (
      <MenuList>
        {filteredContacts?.map((contact, index) => (
          <Fragment key={index}>
            <MenuItem
              key={contact.clientName}
              onClick={() => {
                onContactSelected(contact);
              }}
              {...(selectedContacts.includes(index.toString())
                ? { background: 'gray.100' }
                : {})}
              h='full'
            >
              <ContactDetails
                contact={contact}
                isLastEntry={index === filteredContacts.length - 1}
              />
            </MenuItem>
            {index !== filteredContacts.length - 1 && (
              <MenuDivider color='gray.400' />
            )}
          </Fragment>
        ))}
      </MenuList>
    );
  };

  return (
    <Fragment>
      {canShowDropdown && (
        <Menu size='md' autoSelect={false} placement='bottom'>
          <MenuButton
            as={Button}
            colorScheme='blue'
            fontWeight='normal'
            rightIcon={<Icon as={AiOutlineDown} ml={4} />}
            height={8}
          >
            Select contact
          </MenuButton>
          <Contacts />
        </Menu>
      )}
    </Fragment>
  );
};
